import _extends from "@babel/runtime/helpers/extends";

/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import Button from '../Button';

var DangerButton = function DangerButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({
    kind: "danger"
  }, props));
};

export default DangerButton;